import { Address, CreateAddress, UpdateAddress } from "../../../address/types/models/Address";
import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity RoadCarriers


export interface RoadCarrier {
    id: ID;

    
    name: string;

    
    description?: string;

    
    addressIdAddress?: Address;
    

    
    scopeGroupId: ID;

    }




export interface CreateRoadCarrier {
    
    name: string;

    
    description?: string;

    
    addressIdAddress?: CreateAddress;
    

    
    }


export interface UpdateRoadCarrier {
    
    name: string;

    
    description?: string;

    
    addressIdAddress?: UpdateAddress;
    

    
    }

export interface PresentationRoadCarrierRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryRoadCarrier {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: RoadCarrier): PrimaryRoadCarrier | undefined {
        return entity ? new PrimaryRoadCarrier(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryRoadCarrier {
        return new PrimaryRoadCarrier(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryRoadCarrier {
        let vals = path?.split('/');
        return new PrimaryRoadCarrier(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryRoadCarrier[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: RoadCarrier): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityRoadCarrier {
    id: PrimaryRoadCarrier;
    data: UpdateRoadCarrier;


    constructor(id: PrimaryRoadCarrier, data: UpdateRoadCarrier) {
        this.id = id;
        this.data = data;
    }
}
